// A GitHub file's first-line H1 is the Workplace doc title. Save to GitHub
// writes it back as `# Title`, so import and pull both lift it out of the
// body rather than repeating it there.
const LEADING_H1 = /^#[ \t]+(.+?)[ \t]*(?:\r?\n|$)/;

export function splitMarkdownTitle(markdown: string): {
  title: string | null;
  body: string;
} {
  const match = LEADING_H1.exec(markdown);
  if (!match) return { title: null, body: markdown };
  return {
    title: match[1].trim(),
    body: markdown.slice(match[0].length).replace(/^(?:[ \t]*\r?\n)+/, ''),
  };
}
